import { usePermissions } from './usePermissions';
import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

/**
 * Custom hook for fetching usage data with caching
 * Cached for 1 minute, stored for 5 minutes
 */
export function useUsage(enabled: boolean = true) {
  const { workspaceId, hasPermission } = usePermissions();
  return useQuery({
    queryKey: ['usage', workspaceId],
    queryFn: () => apiService.getUsage(workspaceId),
    staleTime: 60000, // 1 minute
    gcTime: 300000, // 5 minutes
    enabled: enabled && !!workspaceId && hasPermission('billing:read'),
  });
}
